import { PDFDownloadLink, PDFViewer, StyleSheet } from '@react-pdf/renderer';
import { Fragment, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PdfDocument from './Invoice';
import { CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify'
import * as constants from '../../../utils/Constants'

const styles = StyleSheet.create({
  link: {
    fontFamily: 'Helvetica',
    color: 'blue',
    cursor: 'pointer'
  }
});

function DownloadInvoice() {
  const { state } = useLocation()
  const [isSpin, setIsSpin] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  // console.log("state: ", state)
  const loggedInUser = JSON.parse(localStorage.getItem('user'))

  const submitHandler = (e) => {
    fetch(`${constants.SubmitInvoiceDetailsUrl}/${state.invoiceNumber}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${loggedInUser.sessionToken}`,
      }
    })
      .then(response => response.json())
      .then(res => {
        if (res.message) {
          toast.success(`✅ ${res.message.messageDescription} !`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })

          setTimeout(() => {
            setIsSubmitted(true)
            setIsSpin(false)
          }, 3000);

        }
        else {
          toast.error(`❌ ${res.error.errorMessage} !`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
          setTimeout(() => {
            setIsSpin(false)
            setIsSubmitted(false)
          }, 3000);

        }
      })
  }

  return (
    <Fragment>
      <div className="card-body">
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 'large', fontWight: 'bold', color: 'blue', cursor: 'pointer' }}>
            {
              loggedInUser.roles === 'Recruitment Agent' &&
              (
                isSpin ?
                  <button
                    type="button"
                    className="btn bg-white text-primary btn-block">
                    < CircularProgress
                      color='inherit' size={24}
                      sx={{
                        color: 'green'
                      }} />
                  </button>
                  :
                  (state?.applyJob?.isInvoiceGenerated === 0 && !isSubmitted) &&
                  <button style={{ border: 'none', backgroundColor: '#00ADEE', marginBottom: '10px' }}
                    type="submit"
                    className="btn btn-primary"
                    onClick={(e) => submitHandler(e)}
                  >
                    Submit
                    <ToastContainer />
                  </button>
              )
            }
            &nbsp;&nbsp;
            <PDFDownloadLink style={styles.link}
              document={<PdfDocument invoicedata={state} />}
              fileName={state.invoiceNumber}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Loading..." : "Download Invoice"
              }
            </PDFDownloadLink>
          </div>
          <PDFViewer width={800} height={600}>
            <PdfDocument invoicedata={state} />
          </PDFViewer>
        </div>
      </div>

    </Fragment >
  );
}

export default DownloadInvoice;